import { DialogService } from 'primeng/dynamicdialog';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { LayoutService } from '../service/app.layout.service';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, NgClass } from '@angular/common';
import { Subject } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { UserDetailComponent } from '../../pages/user/user-detail/user-detail.component';
import { UserService } from '../../pages/user/services/user.service';
import { ToastModule } from 'primeng/toast';
import { AuthService } from '../../services/guard/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { User } from '../../pages/user/models/user.type';
import * as _ from "lodash";
import { BadgeModule } from 'primeng/badge';
import { NotificationComponent } from "../../utils/notification/notification.component";
@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NgClass,
    DialogModule,
    ButtonModule,
    AvatarModule,
    UserDetailComponent,
    ToastModule,
    TranslateModule,
    NgClass,
    BadgeModule,
    NotificationComponent
],
  templateUrl: './app.topbar.component.html',
  styleUrl: './app.topbar.component.scss',
  providers: [DialogService, MessageService, TranslateService],
})
export class AppTopBarComponent {
  destroy$: Subject<boolean> = new Subject<boolean>();
  items!: MenuItem[];
  collapsed: boolean = false;
  editable: boolean = false;
  visible = false;
  formNotTouch = true;
  user: User;
  userCopie: User;
  menuHidden = false;
  buttonEnabled = false;
  @ViewChild('menubutton') menuButton!: ElementRef;
  @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;
  @ViewChild('topbarmenu') menu!: ElementRef;
  @ViewChild('userDetail') userDetail!: UserDetailComponent;

  constructor(
    public layoutService: LayoutService,
    private readonly userService: UserService,
    private readonly router: Router,
    public messageService: MessageService,
    private readonly authService: AuthService,
    private readonly translate: TranslateService,
  ) {
    this.user = this.userService.getUser();
    this.userCopie = _.cloneDeep(this.user);
  }

  collapse() {
    this.collapsed = this.layoutService.onMenuToggle().staticMenuDesktopInactive;
  }

  toggle() {
    this.menuHidden = this.layoutService.state.staticMenuDesktopInactive;
  }

  updateForm() {
    this.hideModal();
    const user = {
      email: this.user?.email,
      firstname: this.user?.firstname,
      lastname: this.user?.lastname,
      shopCode: this.user.defaultShop?.shopCode,
      shopName: this.user.defaultShop?.shopName,
      channelCode: this.user.defaultChannel?.channelCode,
      defaultLanguage: this.user.defaultLanguage,
      phoneNumber: this.user?.phoneNumber,
      isSeller: this.userService.isDefaultSeller(this.user),
      defaultHomePage: this.user.defaultHomePage?.['key']
    };
    this.translate.use(user.defaultLanguage.languageCode.toLowerCase());
    this.userService.updateUser(user).subscribe({
      next: () => {
        this.userService.setUser(this.user);
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('messages.success'),
          detail: this.translate.instant('messages.saveSuccess'),
        });
        this.userDetail.ngOnInit();
        this.userCopie = _.cloneDeep(this.user)
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('messages.error'),
          detail: this.translate.instant('messages.errorSummary'),
        });
      },
    });
  }

  reloadPage() {
    globalThis.location.reload();
  }

  hideModal() {
    this.editable = false;
    this.visible = false;
    this.formNotTouch = true;
  }

  changeBtnStatus(user) {
    this.user = user;
    this.formNotTouch = false;
  }

  formValid(valid: boolean) {
    this.buttonEnabled = valid;
  }

  showProfile() {
    this.visible = true;
  }

  logout() {
    this.visible = false;
    this.authService.logout();
  }

  closeDialog() {
    this.hideModal();
    this.messageService.add({
      severity: 'success',
      summary: this.translate.instant('messages.success'),
      detail: this.translate.instant('messages.emailSent'),
      life: 3000,
    });
  }
}
